// extracted by mini-css-extract-plugin
export default {"wrapper":"more_wrapper__l4wgK"};